module.exports = __webpack_public_path__ + "img/statistic.7b063aa6.png";